import { createSlice } from "@reduxjs/toolkit";

const initialKontrakState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  kontrakForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const kontrakSlice = createSlice({
  name: "kontrak",
  initialState: initialKontrakState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		kontrakFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    kontrakCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.kontrak.push(action.payload.kontrak);
    },
    kontrakDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.kontrak.filter(el => el.kontrak_id !== action.payload.id);
    },
    getKontrak: (state, action) => {
      state.actionsLoading = false;
      state.kontrakForEdit = action.payload.kontrakForEdit;
      state.error = null;
    },
    // updateProduct
    kontrakUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.kontrak = state.entities.kontrak.map(entity => {
        if (entity.kontrak_id === action.payload.kontrak.kontrak_id) {
          return action.payload.kontrak;
        }
        return entity;
      });
    },
  },
});
